import cx from 'classnames';
import React from 'react';

import * as styles from './Content.module.css';

const Content = ({
	children,
	theme = 'standard',
	align,
	valign,
	clamp,
	extrapad,
	as: Component = 'div',
	className = '',
	boxed
}: {
	children: React.ReactNode | React.ReactElement;
	theme?: 'standard' | 'deep' | 'block' | 'space';
	align?: 'left' | 'center' | 'right';
	valign?: 'top' | 'center' | 'bottom';
	clamp?: boolean;
	extrapad?: 'xl' | 'lg' | 'md';
	as?: React.ElementType;
	className?: string;
	boxed?: 'white';
}) => {
	return (
		<Component
			className={cx(styles.content, styles[theme], className, {
				['rhythm']:
					theme === 'deep' || theme === 'block' || theme === 'space' || !theme,
				['beat']: theme === 'standard',
				[styles[`${align}Align`]]: align,
				[styles[`${valign}Valign`]]: valign,
				[styles.clamp]: clamp,
				[styles[`${extrapad}Pad`]]: align,
				[styles[`${boxed}Box`]]: boxed,
			})}
		>
			{children}
		</Component>
	);
};

export default Content;
